import CollectionList_2 from './CollectionList_2';
import CollectionList_5 from './CollectionList_5';

export const CollectionList = {
  CollectionList_2: CollectionList_2,
  CollectionList_5: CollectionList_5,
};
